module.exports = __webpack_public_path__ + "static/media/yellowsapphero.5d19f8b6.jpg";